'use client';

import type { ProjectWithAllRelations } from '@repo/database';
import React from 'react';
import { jarUrlBuilder } from '@repo/monobank-sdk/core';
import ButtonLink, {
  ButtonSize,
  ButtonStyle,
} from '../../../../components/button-link';
import { DonateIcon } from '../../vector-images/donate-icon';

export function ActionButtons({
  project,
  className,
  activeJarId = null,
}: {
  project: ProjectWithAllRelations;
  className: string;
  activeJarId: string | null;
}): React.JSX.Element {
  const scroll = (): void => {
    const section = document.querySelector('#description-section');
    section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className={`flex flex-row gap-x-5 md:gap-x-10 ${className || ''}`}>
      <ButtonLink
        disabled={!activeJarId}
        href={activeJarId ? jarUrlBuilder(activeJarId) : '#'}
        icon={<DonateIcon />}
        size={ButtonSize.Large}
        style={ButtonStyle.Primary}
        target='_blank'>
        Донат
      </ButtonLink>

      <ButtonLink
        href={project.pageButton?.url || undefined}
        onClick={!project.pageButton?.url ? scroll : undefined}
        size={ButtonSize.Large}
        style={ButtonStyle.Secondary}
        target='_blank'>
        {project.pageButton?.label || 'Детальніше'}
      </ButtonLink>
    </div>
  );
}
